export default {
  couponListData: (state) => state.couponListData,
};
